<template>
  <b-modal
    id="manual-activity"
    ref="manual-activity"
    size="manual-clock"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <i class="atto atto-alert-triangle" />
      <span
        v-if="!activity.timesheet || (activity.timesheet && activity.timesheet.status === 1)"
        class="modal-title"
      >{{ label.get('manual_clock_in') }}!</span>
      <span
        v-if="activity.timesheet && (activity.timesheet.status === 0 || activity.timesheet.status === 4)"
        class="modal-title"
      >{{ label.get('manual_clock_out') }}!</span>
      <button
        class="close-modal"
        @click="close"
      >
        <i class="atto atto-close-btn" />
      </button>
    </div>
    <div class="content-wrapper">
      <div class="field-row">
        <p
          v-if="!activity.timesheet || (activity.timesheet && activity.timesheet.status === 1)"
          v-html="label.get('manual_activity_clock_in_description', {activity_name :activity.name})"
        />
        <p
          v-if="activity.timesheet && (activity.timesheet.status === 0 || activity.timesheet.status === 4)"
          v-html="label.get('manual_activity_clock_out_description', {activity_name :activity.name})"
        />
      </div>
    </div>
    <div class="modal-footer">
      <button
        v-if="!activity.timesheet || (activity.timesheet && activity.timesheet.status === 1)"
        class="atto-btn confirm"
        :disabled="buttonDisabled"
        @click="confirmClockIn(activity)"
      >
        {{label.get('clock_in')}}
      </button>
      <button
        v-if="activity.timesheet && (activity.timesheet.status === 0 || activity.timesheet.status === 4)"
        class="atto-btn confirm"
        :disabled="buttonDisabled"
        @click="confirmClockOut(activity)"
      >
        {{label.get('clock_out')}}
      </button>
    </div>
  </b-modal>
</template>

<script>
    import ActivityService from '../shared/ActivityService';
    import UtilsService from '../../../shared/services/UtilsService';
    export default {
        name: "ManualActivityComponent",
        props: {
          activity: {
            type: Object,
            default: () => {
              return {};
            }
          }
        },
        data(){
            return{
                userId: null,
                localId: null,
                start: null,
                timesheet_id: null,
                completeAnimation: false,
                buttonDisabled: false
            }
        },
        mounted() {
            this.$refs['manual-activity'].show();
        },
        methods: {
            confirmClockIn: function (activity) {
                let data = {
                    user_id: activity.id,
                    local_id: UtilsService.getUUID(),
                    start: this.$moment.utc().format('YYYY-MM-DD HH:mm:ss')
                };
                this.buttonDisabled = true;
                this.$store.commit('showLoading');
                ActivityService.manualClockIn(data).then((result) => {
                    this.$root.$emit('reloadMemberActivity');
                    this.$root.$emit('reloadActivities');
                    this.$root.$emit('hideManualClockInOut');
                    this.$store.commit('hideLoading');
                    this.buttonDisabled = false;
                }).catch(error => {
                    this.buttonDisabled = false;
                });
            },
            confirmClockOut: function (activity) {
                const data = {
                    user_id: activity.id,
                    local_id: activity.timesheet.id
                };
                this.buttonDisabled = true;
                this.$store.commit('showLoading');
                ActivityService.manualClockOut(data).then((result) => {
                    this.$root.$emit('reloadMemberActivity');
                    this.$root.$emit('reloadActivities');
                    this.$root.$emit('hideManualClockInOut');
                    this.$store.commit('hideLoading');
                    this.buttonDisabled = false;
                }).catch((error) => {
                    this.buttonDisabled = false;
                });
            },
            close(){
                this.$root.$emit('hideManualClockInOut');
            }

        }
    }
</script>
